export const ModalID = 'image_modal';
